import { isValidPnumFormat } from "./rowUtils";

function setField(result, key, level, message) {
  result.fieldStatus[key] = level;
  result.fieldMessages[key] = message;
  if (level === "error") result.hasError = true;
  if (level === "warning") result.hasWarning = true;
}

function resolveWorkplace(row, { rdvMap, defaultWorkplace, defaultRdvId }) {
  const name = String(row.workplace ?? "").trim() || defaultWorkplace;
  if (!name) return { rdvId: defaultRdvId, workplace: "", error: "근무지(집결지)를 입력하세요" };

  const hit = rdvMap.get(name);
  if (hit) {
    return {
      rdvId: hit.rdv_id,
      workplace: name,
      siteId: hit.site_id ?? null,
      error: null,
    };
  }
  if (defaultRdvId && !String(row.workplace ?? "").trim()) {
    return {
      rdvId: defaultRdvId,
      workplace: defaultWorkplace,
      error: null,
    };
  }
  return {
    rdvId: null,
    workplace: name,
    error: `근무지를 찾을 수 없습니다: "${name}"`,
  };
}

export function validateSingleRow(
  row,
  { rdvMap, defaultWorkplace = "", defaultRdvId = null } = {},
) {
  const fieldStatus = {};
  const fieldMessages = {};
  const result = {
    fieldStatus,
    fieldMessages,
    hasError: false,
    hasWarning: false,
  };

  const pname = String(row.pname ?? "").trim();
  if (!pname) {
    setField(result, "pname", "error", "이름은 필수입니다");
  } else {
    fieldStatus.pname = "ok";
  }

  const wp = resolveWorkplace(row, { rdvMap, defaultWorkplace, defaultRdvId });
  if (wp.error) {
    setField(result, "workplace", "error", wp.error);
  } else {
    fieldStatus.workplace = "ok";
  }

  const pphone = String(row.pphone ?? "").trim();
  if (pphone && !isValidPnumFormat(pphone)) {
    setField(result, "pphone", "error", "전화번호 형식 오류 (000-0000-0000)");
  } else if (pphone) {
    fieldStatus.pphone = "ok";
  }

  ["porg", "pdept", "prank", "dutyDesc"].forEach((key) => {
    if (String(row[key] ?? "").trim()) fieldStatus[key] = "ok";
  });

  let rowStatus = "normal";
  if (result.hasError) rowStatus = "error";
  else if (result.hasWarning) rowStatus = "warning";
  else if (Object.keys(fieldStatus).length === 0) rowStatus = "pending";

  return {
    ...row,
    workplace: wp.workplace || row.workplace,
    rdvId: wp.rdvId,
    siteId: wp.siteId,
    fieldStatus,
    fieldMessages,
    rowStatus,
  };
}

export function validateRows(rows, options) {
  return rows.map((row) => validateSingleRow(row, options));
}

export function countValidation(rows) {
  let errors = 0;
  let warnings = 0;
  let normal = 0;
  rows.forEach((row) => {
    if (row.rowStatus === "error") errors += 1;
    else if (row.rowStatus === "warning") warnings += 1;
    else if (row.rowStatus === "normal") normal += 1;
  });
  return { errors, warnings, normal, total: rows.length };
}

export function buildRdvMap(dsRdvs = [], dsSites = []) {
  const map = new Map();
  dsRdvs.forEach((r) => {
    const name = String(r.rname ?? "").trim();
    if (name) map.set(name, { rdv_id: Number(r.rdv_id), site_id: null, rname: name });
  });
  dsSites.forEach((s) => {
    const name = String(s.sname ?? s.rname ?? "").trim();
    if (name) {
      map.set(name, {
        rdv_id: null,
        site_id: Number(s.snum ?? s.site_id),
        rname: name,
      });
    }
  });
  return map;
}
